import { v4 as uuidv4 } from 'uuid'
import { useTranslation } from 'react-i18next'
import { format } from 'date-fns'

import {
  Table,
  TableBody,
  Box,
  TableContainer,
  alpha,
  Button,
} from '@mui/material'
import { GlobalReportLibraryColumnProps } from '@/state/reports/models'
import { dateTimeTableFormat } from '@/constants/date'

import { colors } from '@/theme/colors.theme'
import PaginationTable from '@/views/components/pagination-table/index.component'
import NoContentAvailable from '@/views/components/no-content-available/index.component'

import useGlobalReports from '@/views/reports/hooks/use-reports-type-global.hooks'
import useReportsFilters from '@/views/reports/hooks/use-reports-filters.hooks'
import ReportTableRow from './row.component'

import ReportTableHead from './head.component'
import ReportTableFoot from './footer.component'

const ReportsTableComponent = () => {
  const { t } = useTranslation()

  const {
    sortedRows,
    createSortHandler,
    order,
    orderBy,
    headCells,
    globalPagination,
    filters,
    headXlsxCells,
    getNameColumn,
    getFormattedRow,
  } = useGlobalReports()

  const { handleChangePage, handleChangeLimit, downloadXlsxSearchFilter } =
    useReportsFilters()

  const fileName = `${getNameColumn()}-${format(
    new Date(),
    dateTimeTableFormat,
  )}`

  const xlsxButton = (
    <Button
      onClick={() =>
        downloadXlsxSearchFilter(
          { ...filters, page: 1, limit: 999999, xlsx: true },
          headXlsxCells,
          fileName,
          getFormattedRow,
        )
      }
      variant="contained"
    >
      {t('labels.downloadAsXLS')}
    </Button>
  )

  return (
    <>
      <TableContainer>
        <Table>
          <ReportTableHead
            order={order}
            orderBy={orderBy}
            createSortHandler={createSortHandler}
            headCells={headCells}
          />
          <TableBody>
            {sortedRows.length > 0 &&
              sortedRows.map((row: GlobalReportLibraryColumnProps) => {
                return (
                  <ReportTableRow
                    key={uuidv4()}
                    row={row}
                    reportType={filters.reportType}
                  />
                )
              })}
          </TableBody>
          {<ReportTableFoot />}
        </Table>
      </TableContainer>
      <>
        {sortedRows.length !== 0 ? (
          <PaginationTable
            pagination={globalPagination}
            leftContent={xlsxButton}
            handleChangePage={handleChangePage}
            handleChangeLimit={handleChangeLimit}
          />
        ) : (
          <Box
            display="flex"
            flexDirection="column"
            flexGrow={1}
            justifyContent="center"
            border={1}
            borderColor={alpha(colors.white, 0.3)}
            py={5}
          >
            <NoContentAvailable
              title={t('noResultsFound')}
              instruction={t('noResultsFoundCaption')}
            />
          </Box>
        )}
      </>
    </>
  )
}

export default ReportsTableComponent
